import { useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
    const location = useLocation();

    const formatBreadcrumb = (str) => {
        return str
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const pathNames = location.pathname.split("/").filter((x) => x);

    return (
        <ol className="breadcrumb m-0">
            <li className="breadcrumb-item">
                <a href="/">Dashboard</a>
            </li>
            {pathNames.map((value, index) => {
                const isLast = index === pathNames.length - 1;
                const to = `/${pathNames.slice(0, index + 1).join("/")}`;
                const label = formatBreadcrumb(value);

                return isLast ? (
                    <li className="breadcrumb-item active" aria-current="page" key={to}>
                        {label}
                    </li>
                ) : (
                    <li className="breadcrumb-item" key={to}>
                        <a href={to}>{label}</a>
                    </li>
                );
            })}
        </ol>
    );
};

export default Breadcrumbs;
